import { createFileRoute } from '@tanstack/react-router';

import { Box } from '@mantine/core';

import { useLegalEntityContext } from '@/context/LegalEntityContext';
import { TaskGenConfigPanel } from '@/features/legal-entities/components/TaskGenConfigPanel';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/company/task-gen')({
  component: CompanyTaskGenPage,
  head: () => buildHead('taskGeneration'),
});

function CompanyTaskGenPage() {
  const { activeEntity } = useLegalEntityContext();

  if (!activeEntity) return null;

  return (
    <Box px='xl' py='lg'>
      <TaskGenConfigPanel entityId={activeEntity.id} />
    </Box>
  );
}
